import AreasOfSupportComponent from "../../components/request-support/areas-of-support";

const AreasOfSupportPage = () => <AreasOfSupportComponent />

export default AreasOfSupportPage;